(() => {
  if (window.EurosolApplicationPreviewInitialized) return;
  window.EurosolApplicationPreviewInitialized = true;

  document.addEventListener('click', (event) => {
    const toggle = event.target.closest('.eurosol-application-preview__toggle');
    if (!toggle) return;

    const card = toggle.closest('.card');
    if (!card) return;

    const isApplicationActive = !card.classList.contains('is-application-active');
    card.classList.toggle('is-application-active', isApplicationActive);
    toggle.setAttribute('aria-pressed', String(isApplicationActive));

    const productTitle = toggle.dataset.productTitle || 'Produkt';
    const label = toggle.querySelector('span');
    if (label) label.textContent = isApplicationActive ? 'Produkt' : 'Anwendung';
    toggle.setAttribute(
      'aria-label',
      isApplicationActive
        ? `Produktbild für ${productTitle} anzeigen`
        : `Anwendungsbild für ${productTitle} anzeigen`
    );
  });
})();
